"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const LitigationEdit_vue_1 = __importDefault(require("./LitigationEdit.vue"));
const litigation_1 = __importDefault(require("@/pages/index/api/litigation"));
const ApplicationInfo_vue_1 = __importDefault(require("./ApplicationInfo.vue"));
const ContractArea_vue_1 = __importDefault(require("./ContractArea.vue"));
const litigation_2 = require("@/pages/index/select/litigation");
const file_1 = require("@/pages/index/utils/file");
const litigationLogFlowConfig_1 = __importDefault(require("../log/litigationLogFlowConfig"));
const mainData_1 = __importDefault(require("./../log/mainData"));
exports.default = (0, vue_1.defineComponent)({
    name: 'LitigationApplicationInfo',
    components: {
        LitigationEdit: LitigationEdit_vue_1.default,
        ApplicationInfo: ApplicationInfo_vue_1.default,
        ContractArea: ContractArea_vue_1.default,
    },
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            mainData: mainData_1.default,
            detail: undefined,
            applyLitigationId: undefined,
            next: undefined,
            flow: {
                data: litigationLogFlowConfig_1.default,
                key: undefined
            }
        };
    },
    computed: {
        currentOverdueRecordId() {
            if (this.detail) {
                return this.detail.overdueRecordId;
            }
            else {
                return undefined;
            }
        },
        process() {
            return this.detail ? Number(this.detail.litigationStatus.value) : 0;
        }
    },
    watch: {
        id() {
            this.$nextTick(() => {
                this.init();
            });
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.detail = undefined;
            const flowEdit = this.$refs['litigation-edit'];
            (0, file_1.getFileWithPromise)(litigation_1.default.litigationLogInfo.require({
                id: this.id
            }), this.id, 'litigationLog').then(res => {
                const detail = this.mainData.$createDataByDictionary(res.data);
                detail.fileList = [];
                if (res.file) {
                    res.file.forEach(item => {
                        detail.fileList.push(item);
                    });
                }
                this.detail = detail;
                this.flow.key = '50';
                this.next = litigation_2.logStatus.getNext(this.detail.litigationStatus.process);
                flowEdit.init(this.flow.key, this.detail);
            });
        }
    }
});
